// extracted by mini-css-extract-plugin
export default {"benefit":"_26cec3d2","icon":"_2e06e2ce","text":"_82415c98"};